import { Flex, Input } from "antd";
import { ColumnType } from "antd/lib/table";
import { BaseButton } from "components/button/button-base";
import { Text } from "components/mvp-typography";

/**
 * Helper method to generate a filter configuration for the "Question" column of the inventory-table-display
 *
 * The filter allows a user to search for questions by a substring
 */
export function generateQuestionFilterColumnConfig<
  T extends { question: string }
>(): ColumnType<T> {
  return {
    onFilter: (val, record) =>
      record.question.toLowerCase().includes(val.toString().toLowerCase()),
    filterDropdown: filterDropdownProps => (
      <Flex
        onKeyDown={e => e.stopPropagation()}
        gap={6}
        vertical
        style={{
          padding: '1rem'
        }}
      >
        <Text>Filter questions that contain...</Text>
        <Input
          placeholder='e.g: "do you have difficulty getting out of bed?"'
          onChange={e =>
            filterDropdownProps.setSelectedKeys(
              e.target.value ? [e.target.value] : []
            )
          }
          onPressEnter={() => filterDropdownProps.confirm()}
        />
        <Flex gap={4}>
          <BaseButton
            onClick={() => {
              filterDropdownProps.confirm();
            }}
          >
            Search
          </BaseButton>
          <BaseButton
            disabled={!!filterDropdownProps.clearFilters}
            onClick={() => {
              filterDropdownProps.clearFilters?.();
            }}
          >
            Reset
          </BaseButton>
          <BaseButton
            onClick={() => {
              filterDropdownProps.close();
            }}
          >
            Close
          </BaseButton>
        </Flex>
      </Flex>
    )
  };
}
